const labMeasurementReaderEn = {
	labMeasurementReaderEditForm: 'Lab Measurement Reader',
	labMeasurementReaderTable: 'Lab Measurement Reader',
	name: 'Name',
	username: 'Username',
	password: 'Password',
	server: 'Server',
	database: 'Database',
	location: 'Location',
	labConnection: 'Lab Connection',
	driver_type: 'Driver Type',
	driverType: 'Driver Type',
	reader: 'Reader',
	sampling_point: 'Sampling point',
	analysis: 'Analysis',
	aspect: 'Aspect',
	component: 'Component',
	basic: 'Basic',
	fields: 'Fields',
	api_url: 'API URL',
	server_id: 'Server Id',
	time_zone: 'Timezone',
	tag_name: 'Tag name',
	start_date_time: 'Kezdődátum',
	end_date_time: 'Végdátum',
	summary_type: 'Summary type',
	summary_duration: 'Summary duration',
	summary_duration_unit: 'Summary duration unit',
	uom: 'UOM',
	category: 'Category',
	type: 'Type',
	value: 'Value',
	tag: 'Tag',
	expression: 'Expression',
	component_map: 'List',
	userGroup: 'User Group'
};

export default labMeasurementReaderEn;
